/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PublicFormEntryResource } from '../models/PublicFormEntryResource';
import type { PublicFormResource } from '../models/PublicFormResource';
import type { PublicFormSubmitRequest } from '../models/PublicFormSubmitRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PublicFormsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get a public form's render configuration
     * @returns any OK
     * @throws ApiError
     */
    public getPublicForm({
        subdomain,
        slug,
    }: {
        /**
         * Subdomain of the organization the form belongs to
         */
        subdomain: string,
        /**
         * The form's url_slug
         */
        slug: string,
    }): CancelablePromise<{
        data: PublicFormResource;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/forms/public/{subdomain}/{slug}',
            path: {
                'subdomain': subdomain,
                'slug': slug,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Submit a public form entry
     * @returns any Created
     * @throws ApiError
     */
    public submitPublicForm({
        subdomain,
        slug,
        requestBody,
    }: {
        /**
         * Subdomain of the organization the form belongs to
         */
        subdomain: string,
        /**
         * The form's url_slug
         */
        slug: string,
        /**
         * Form submission
         */
        requestBody: PublicFormSubmitRequest,
    }): CancelablePromise<{
        data: PublicFormEntryResource;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/forms/public/{subdomain}/{slug}',
            path: {
                'subdomain': subdomain,
                'slug': slug,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                404: `Not Found`,
                409: `The form is disabled, at capacity, requires payment, or otherwise not accepting submissions`,
            },
        });
    }

}
